<template>
  <div v-if="inputAudioData" class="daily-audio">
    <div v-for="(item, index) in inputAudioData" :key="index">
      <div class="title d-flex justify-content-around align-self-center">
        <div style="width:50%; text-align: left;">
          <h5 class="date">{{moment(item.publish_at).format('YYYY/MM/DD') }}
            <!-- <span v-if="inputAudioData.length>1" class="badge badge-danger mx-1">{{item.category.name}}</span> -->
          </h5>
        </div>
        <div style="width:50%; text-align: right;">
          <span v-if="!item.collection" @click="addCollections(item)" class="pointer p-2">
            <img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_mark_off.png" alt="">
            <span class="rwd-hide">{{ $t('Home.Keep') }}</span>
          </span>
          <span v-else  @click="removeCollections(item.id)" class="pointer p-2">
            <img class="pointer" src="../assets/image/pic/btn_function_mark_on.png" alt="">
            <span class="rwd-hide">{{ $t('Home.Keep') }}</span>
          </span>
          <span v-if="$route.name==='Home'" class="pointer p-2" @click="$router.push({ name: 'Sentence'})"><img  src="../assets/image/icon&btn/icon_have_btn_function/btn_function_show_list.png" alt="">
          <span class="rwd-hide">{{ $t('Home.watch_more') }}</span>
          </span>
        </div>
      </div>
      <div class="daily-box" style="min-height:100px !important">
        <div>
          <h4 class="d-flex align-items-center flex-wrap">
            <span class="pointer pr-2" @click="playSentences(index)">
              <img style="width:30px" src="../assets/image/icon&btn/icon_have_btn_function/btn_function_play_voice.png" alt="">
            </span>
            <div class="rwd-font-size px-1 sentence" v-for="(el, idx) in splitSentence(item)" :key="idx">
              <span v-if="item.dict" :class="{'dict': item.dict.find((i=>{ return i.key.toLowerCase() === el.toLowerCase()})), 'focus': getFocusVocabulary(item).find((i=>{ return i.toLowerCase() === el.toLowerCase()}))}" @click="setVocabulary(el, item, index, idx)">
                {{el}}
              </span>
              <span v-else>
                {{el}}
              </span>
              <div class="sentence-box" v-if="vocabularyIdx===idx && currentIndex===index && vocabularyData && vocabularyData.key.toLowerCase() === el.toLowerCase()">
                <div class="sentence">
                  <font-awesome-icon class="pointer close" @click="closeDict" size="lg" :icon="['fa', 'times']"  style="color:rgba(255, 0, 0, .6);float: right;"/>
                  <h5 class="sentence-title">
                    {{vocabularyData.key}}
                    <span class="pointer" @click="playVocabulary(el)">
                      <img style="width:30px" src="../assets/image/icon&btn/icon_have_btn_function/btn_function_play_voice.png" alt="">
                    </span>
                  </h5>
                  <p class="sentence-phon">
                    {{vocabularyData.part_of_speech}} {{vocabularyData.phon}}
                  </p>
                  <p class="sentence-explain">
                    {{vocabularyData.expl}}
                  </p>
                </div>
                <audio v-if="vocabularyData" :id="`vocabulary${el}`" :ref="`vocabulary`">
                  <source :src="`https://api.liveabc.com/v1/livelibrary/Dict/Word/${vocabularyData.key}/audio`" type="audio/mp3">
                </audio>
              </div>
            </div>
          </h4>
          <h4 class="my-auto rwd-font-size px-1">{{item.local}}</h4>
        </div>
      </div>
      <audio :id="`daily-sentences${index}`" :ref="`sentences`">
        <source :src="item.audio_url" type="audio/mp3">
      </audio>
      <slot name="line">
      </slot>
    </div>
  </div>
</template>

<script>
import api from '../store/api';
export default {
  name: 'DailySentence',
  data () {
    return {
      vocabularyData: null,
      vocabularyIdx: 0,
      currentIndex: null
    }
  },
  components: {
  },
  props: {
    inputAudioData: {
      required: true
    }
  },
  computed: {
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.audio ? this.$refs.audio.load() : null
    })
  },
  methods: {
    playSentences (id) {
      let audio = document.getElementById(`daily-sentences${id}`)
      this.pauseAll()
      audio.load()
      audio.play()
    },
    playVocabulary (el) {
      let audio = document.getElementById(`vocabulary${el}`)
      this.pauseAll()
      audio.load()
      audio.play()
    },
    pauseAll () {
      const audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        // 将audios中其他的audio全部暂停
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    close (close) {
      this.toggle = close
    },
    async addCollections (el) {
      try {
        const fileData = new window.FormData()
        fileData.append('name', el.english)
        fileData.append('json', JSON.stringify(el))
        await api.post(`collections/daily_sentence/${el.id}`, fileData)
        this.$parent.getDailySentences()
      } catch (error) {
        console.error(error.response.data)
      }
    },
    async removeCollections (id) {
      try {
        await api.delete(`collections/daily_sentence/${id}`)
        this.$parent.getDailySentences()
      } catch (error) {
        console.error(error.response.data)
      }
    },
    setVocabulary (val,el,index,idx) {
      this.currentIndex = index
      this.vocabularyIdx = idx
      let dict = el.dict
      for (let i in dict) {
        if (dict[i].key.toLowerCase() === val.toLowerCase()) {
          this.vocabularyData = dict[i]
        }
      }
    },
    closeDict () {
      this.vocabularyData = null
    },
    splitSentence(el) {
      const sent = el.sent
      const dict = el.dict

      const sorted = [...dict].sort((a, b) => a.char_index - b.char_index)

      const result = []
      let lastIndex = 0

      for (const entry of sorted) {
        const { char_index, char_length } = entry
        if (char_index > lastIndex) {
          const inBetween = sent.substring(lastIndex, char_index).trim()
          if (inBetween) {
            result.push(...inBetween.split(/\s+/).filter(Boolean))
          }
        }
        const phrase = sent.substring(char_index, char_index + char_length).trim()
        if (phrase) {
          result.push(phrase)
        }
        lastIndex = char_index + char_length
      }
      if (lastIndex < sent.length) {
        const endPart = sent.substring(lastIndex).trim()
        if (endPart) {
          result.push(...endPart.split(/\s+/).filter(Boolean))
        }
      }
      return result
    },

    getFocusVocabulary(el) {
      let focus = []
      el.dict.map((e=>{
        if (e.underline === true ) {
          focus.push(e.key)
        }
      }))
      return focus
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/styles/custom.scss";
  .daily-box {
    // padding: 20px;
    h4 {
      line-height: 2rem;
      font-weight: 600;
    }
    text-align: left;
  }
  .date {
    font-size: 1rem;
  }
  .dict {
    cursor: pointer;
  }
  .focus {
    color: red;
    text-decoration: underline;
  }
  .sentence {
    position: relative;
    .sentence-box {
      overflow: auto;
      box-shadow: 3px 3px 5px #afafaf;
      font-size: 1rem;
      padding: 5px 10px;
      width: 250px;
      position: absolute;
      max-height: 200px;
      border: 1px solid red;
      background-color: #fff;
      z-index: 40;
      .sentence {
        .sentence-title {
          color: red;
          line-height: 2.5rem;
          font-weight: 600;
          margin: 0;
        }
        .sentence-phon {
          font-size: .8rem;
          line-height: 1rem;
          margin: 0;
        }
        .sentence-explain {
          font-size: 1rem;
          font-weight: 600;
          line-height: 2rem;
          margin: 0;
        }
      }
    }
  }
  @media screen and (max-width: 450px) {
	.sentence-box {
    position: relative !important;
    width:80vw !important;
  }
}
</style>
